var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-modal',{ref:"disclaimerModal",attrs:{"size":"lg","centered":true,"hide-footer":"","hide-header":"","no-close-on-backdrop":"","no-close-on-esc":""}},[_c('disclaimer-form',{on:{"submit":function($event){return _vm.hideDisclaimerModal()}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }